<script setup lang="ts">
import { useUserPlanStore } from '@/store/userPlanStore'

interface Props {
  showCurrentPlan?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  showCurrentPlan: true
})

const userPlanStore = useUserPlanStore()
const { userPlan } = storeToRefs(userPlanStore)
</script>

<template>
  <strong-g class="pd-rect lo-v-start">
    <label class="bold text-align-left"> フリー </label>
    <main-title class="text-align-left"> 0円 </main-title>
    <div
      v-if="
        props.showCurrentPlan &&
        (userPlan === 'free' || userPlan === 'freeTrial')
      "
      class="lo-v"
    >
      <sup-label>現在のプラン</sup-label>
    </div>
  </strong-g>
</template>
